import { render, staticRenderFns } from "./exceladresaktarim.vue?vue&type=template&id=2709d25c&"
import script from "./exceladresaktarim.vue?vue&type=script&lang=js&"
export * from "./exceladresaktarim.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports